import { createReducer } from 'redux-create-reducer';
import { REQUEST_FORM, RECEIVE_FORM, UPDATE_FORM } from '../actions/form';

const initialState = {
  form: {
    name: undefined,
    textBeforeLines: undefined,
    textAfterLines: undefined,
    lines: [],
  },
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [REQUEST_FORM](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [RECEIVE_FORM](state, action) {
    return {
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [UPDATE_FORM](state, action) {
    return {
      ...state,
      ...action.payload,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export const getForm = state => state.form;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step4/reducers/form.js